import Alpine from 'alpinejs'
import { debounce } from './utilities.js';

window.Alpine = Alpine
Alpine.start()
